import { useContext, useEffect, useState } from 'react'
import './Header.css'

// Library imports
import { AppBar, Avatar, Box, Button, IconButton, Menu, MenuItem, Typography, TextField, ButtonBase, OutlinedInput, FormControl, InputLabel, InputAdornment, ListItemIcon, ListItemText } from '@mui/material'
import { styled } from '@mui/material/styles';

// importing material UI icons
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonIcon from '@mui/icons-material/Person';
import NotificationIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

import { breakpoints } from '../../../utils/constant';
import { NotificationContext } from '../../../contexts/NotificationContext';
import { PowerSettingsNew, Search } from '@mui/icons-material';
import { AuthContext } from '../../../contexts/AuthContext';
import { isMobile, toTitleCase } from '../../../utils/helpers';
import { logout } from '../../../services/Auth';
import useService from '../../../hooks/useService';
import { IPvcUser } from '../../../Models/PVC';
import Cookies from 'universal-cookie';
import { getPvcCenterAddresses } from '../../../services/PVC'



// Styling
const StyledProfileMenu = styled((props: any) => (
    <Menu
        MenuListProps={{
            'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({

}));

function Header({ openSidebar }: { openSidebar?: () => any }) {
    const {user} = useContext(AuthContext)
    const {execute} = useService()
    const [centerName, setCenterName] = useState('');

  
    const getPvcName = async (centerId : any) => {
    let data =   await execute(() => getPvcCenterAddresses({ pvcCenterId: centerId }))
    if (data.data?.[0]?.displayName) {
        setCenterName(data.data[0].displayName)
    }
 
    }
    useEffect(() => {
     
        if(user?.centerId){
            let centerId = user.centerId
            getPvcName(centerId)
        }
       
   
    }, [user])


    return (
        <AppBar className='appbar-header-container' position='static' sx={{
            backgroundColor: isMobile() ? 'var(--secondary_color)' : 'white',
            color: isMobile() ? 'white !important' : 'var(--text_color_2)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            paddingX: '30px',
            paddingY: '10px',
            justifyContent: 'space-between',
            gap: '10px'
        }}>
            <SidebarButton openSidebar={openSidebar} />
            {/* <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <SearchField />
                <IconButton style={{color:'inherit'}}>
                    <NotificationsNoneIcon />
                </IconButton>
            </Box> */}
            <Box>
            {centerName}
            </Box>
            <ProfileMenu />
        </AppBar>
    )
}

function SidebarButton({ openSidebar }: { openSidebar?: () => any }) {
    return window.innerWidth > breakpoints.mobile ?
        <></> :
        <IconButton sx={{ mr: '30px', color:'inherit' }} onClick={openSidebar}><MenuIcon /></IconButton>
}

function SearchField(props: any) {
    const [inputShow, setInputShow] = useState(false);

    const showSearchField = () => {
        setInputShow(true);
    }

    const hideSearchField = () => {
        setInputShow(false);
    }

    return (
        <div style={{ position: 'relative' }}>
            {/* <div > */}
            {/* <FormControl size='small' variant="outlined" className={['input-bar', !inputShow ? 'hidden-input' : ''].join(' ')} style={{color:'inherit'}} >
                <InputLabel  style={{color:'inherit'}} htmlFor="search_input">Search</InputLabel>
                <OutlinedInput style={{color:'inherit'}} id='search_input' label='Search' endAdornment={
                    <InputAdornment position='end' style={{color:'inherit'}}>
                        <IconButton style={{color:'inherit'}} size='small' onClick={hideSearchField}><CloseIcon style={{ width: '20px', height: '20px' }} /></IconButton>
                    </InputAdornment>
                } size='small' fullWidth />
            </FormControl>
            <IconButton className={['search-button', inputShow ? 'hidden-search-button' : ''].join(' ')} onClick={showSearchField}  style={{color:'inherit'}} >
                <Search />
            </IconButton> */}
        </div>
    )
}

function ProfileMenu(props: any) {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const {user} = useContext(AuthContext)
    const {execute} = useService()
    // const user:IPvcUser = JSON.parse(localStorage.getItem('user')!)
    const cookies = new Cookies()
    const { notify } = useContext(NotificationContext)
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logoutHandler = async () => {
        const { data } = await execute(() => logout(null))

        if (data != null) {
            cookies.remove("sessionId");
            notify("Logout successful")
        }
    }

    return (
        <>
            <ButtonBase
                TouchRippleProps={{ style: { color: 'rgba(0,0,0,0.5)' } }}
                LinkComponent='div'
                sx={{
                    display: 'flex',
                    gap: '15px',
                    padding: '5px 10px',
                    borderRadius: '4px',
                    transition:'all 0.15s linear',
                    ':hover': {
                        background: isMobile() ? 'var(--secondary_color)' : '#efefef'
                    }
                }}
                onClick={handleClick} >
                {user?.imageUrl ? 
                <Avatar src={user.imageUrl} /> : 
                <Avatar src='' alt='profile pic' >
                    {user.name ? user.name?.split(' ').map(str => str.substring(0,1)).join('').substring(0,2) : ''}
                </Avatar>}
                <Box>
                    <Typography sx={{
                        fontSize: '14px',
                        letterSpacing: '0.06px',
                        marginBottom: '-2px',
                        lineHeight:'1',
                        textAlign:'justify'
                    }}>
                        {user.name && toTitleCase(user.name)}
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        position: 'relative',
                        marginBottom:'-10px'
                    }}>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: isMobile() ? 'white' : '#696969',
                                borderRadius: '4px',
                                marginTop: '-2px',
                                width: '100%',
                                justifyContent: 'space-between'
                            }}>
                            <Typography sx={{ fontSize: '11px' }}>
                                {user && user.role?.label}
                            </Typography>
                            <KeyboardArrowDownIcon />
                        </Box>
                    </Box>
                </Box>
            </ButtonBase>
            <Menu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{paper:{style:{minWidth: '160px'}}}}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                <MenuItem onClick={logoutHandler}>
                    <ListItemIcon>
                        <PowerSettingsNew fontSize='small' />
                    </ListItemIcon>
                    <ListItemText>Logout</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}

export default Header